import {
  Flex,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
} from "@chakra-ui/react";
import React from "react";
import { TOP_NAV_ZINDEX } from "./Navbar";
import { MobileNavbarHeader } from "./NavbarHeader";
import { NavbarLinks } from "./NavbarLinks";

export function MobileNavbar({ accountId }: { accountId: string }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Flex
        as="nav"
        backgroundColor="gray.900"
        w="full"
        shrink={0}
        align="center"
        justify="flex-end"
        zIndex={TOP_NAV_ZINDEX}
      >
        <MobileNavbarHeader
          accountId={accountId}
          isOpen={false}
          onClick={onOpen}
        />
      </Flex>

      <Drawer placement="left" isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent bgColor="gray.900" maxW="20rem">
          <MobileNavbarHeader
            accountId={accountId}
            isOpen={true}
            onClick={onClose}
          />

          <DrawerBody py={0} px={2} overflowY="auto">
            <NavbarLinks onClose={onClose} isCollapsed={false} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
